webpackJsonp([114276838955818,60335399758886],{

/***/ 111:
/***/ (function(module, exports) {

	module.exports = {"data":{"regions":{"edges":[{"node":{"uid":"latin-america","lang":"en-us","data":{"title":[{"text":"Latin America"}]}}},{"node":{"uid":"africa","lang":"en-us","data":{"title":[{"text":"Africa"}]}}},{"node":{"uid":"europe--central-asia","lang":"en-us","data":{"title":[{"text":"Europe and Central Asia"}]}}},{"node":{"uid":"middle-east-and-north-africa","lang":"en-us","data":{"title":[{"text":"Middle East and North Africa"}]}}},{"node":{"uid":"asia","lang":"en-us","data":{"title":[{"text":"Asia"}]}}},{"node":{"uid":"افريقيا","lang":"ar-eg","data":{"title":[{"text":"افريقيا"}]}}},{"node":{"uid":"امريكا-اللاتينية","lang":"ar-eg","data":{"title":[{"text":"امريكا اللاتينية"}]}}},{"node":{"uid":"اسيا","lang":"ar-eg","data":{"title":[{"text":"اسيا"}]}}},{"node":{"uid":"اوروبا-واسيا-الوسطى","lang":"ar-eg","data":{"title":[{"text":"اوروبا واسيا الوسطى"}]}}},{"node":{"uid":"الشرق-الاوسط-وشمات-افريقيا","lang":"ar-eg","data":{"title":[{"text":"الشرق الاوسط وشمات افريقيا"}]}}},{"node":{"uid":"africa1","lang":"es-mx","data":{"title":[{"text":"África"}]}}},{"node":{"uid":"europa-y-asia-central","lang":"es-mx","data":{"title":[{"text":"Europa y Asia Central"}]}}},{"node":{"uid":"asia1","lang":"es-mx","data":{"title":[{"text":"Asia"}]}}},{"node":{"uid":"oriente-medio-y-africa-del-norte","lang":"es-mx","data":{"title":[{"text":"Medio Oriente y Norte de África "}]}}},{"node":{"uid":"america-latina-y-el-caribe","lang":"es-mx","data":{"title":[{"text":"América Latina y el Caribe"}]}}}]},"campaigns":{"edges":[{"node":{"type":"campaign","uid":"stakeholder-engagement","lang":"en-us","data":{"show_in_navigation":"Yes","title":[{"text":"Stakeholder Engagement"}]}}},{"node":{"type":"campaign","uid":"covid-19","lang":"en-us","data":{"show_in_navigation":"Yes","title":[{"text":"COVID-19"}]}}},{"node":{"type":"campaign","uid":"environment--climate","lang":"en-us","data":{"show_in_navigation":"Yes","title":[{"text":"Environment & Climate"}]}}},{"node":{"type":"campaign","uid":"child-rights","lang":"en-us","data":{"show_in_navigation":"Yes","title":[{"text":"Child Rights"}]}}},{"node":{"type":"campaign","uid":"disability-rights","lang":"en-us","data":{"show_in_navigation":"Yes","title":[{"text":"Disability Rights"}]}}},{"node":{"type":"campaign","uid":"sexual-orientation--gender-identity","lang":"en-us","data":{"show_in_navigation":null,"title":[{"text":"Sexual Orientation & Gender Identity"}]}}},{"node":{"type":"campaign","uid":"orientacion-sexual-y-genero","lang":"es-mx","data":{"show_in_navigation":null,"title":[{"text":"Orientación Sexual y Género"}]}}},{"node":{"type":"campaign","uid":"consulta","lang":"es-mx","data":{"show_in_navigation":null,"title":[{"text":"Participación de las partes interesadas y Divulgación de información"}]}}},{"node":{"type":"campaign","uid":"حقوق-الاشخاص-ذوي-الاعاقة","lang":"ar-eg","data":{"show_in_navigation":null,"title":[{"text":"حقوق الأشخاص ذوي الإعاقة"}]}}},{"node":{"type":"campaign","uid":"البيية-والمناخ","lang":"ar-eg","data":{"show_in_navigation":null,"title":[{"text":"البيئة والمناخ"}]}}},{"node":{"type":"campaign","uid":"مشاركة-اصحاب-المصلحة","lang":"ar-eg","data":{"show_in_navigation":null,"title":[{"text":"إشراك أصحاب المصلحة"}]}}},{"node":{"type":"campaign","uid":"derechos-para-personas-con-discapacidad","lang":"es-mx","data":{"show_in_navigation":null,"title":[{"text":"Derechos de las personas con discapacidad"}]}}},{"node":{"type":"campaign","uid":"derechos-del-nino","lang":"es-mx","data":{"show_in_navigation":null,"title":[{"text":"Derechos del niño"}]}}},{"node":{"type":"campaign","uid":"حقوق-الطفل","lang":"ar-eg","data":{"show_in_navigation":null,"title":[{"text":"حقوق الطفل"}]}}},{"node":{"type":"campaign","uid":"environment--climate---spanish","lang":"es-mx","data":{"show_in_navigation":null,"title":[{"text":"Medio Ambiente y Cambio Climático"}]}}}]},"landing_pages":{"edges":[{"node":{"type":"landing_page","uid":"bic-impact-stories","lang":"en-us","data":{"show_in_navigation":"Show in navigation","title":[{"text":"BIC Impact Stories"}]}}},{"node":{"type":"landing_page","uid":"cpsp","lang":"en-us","data":{"show_in_navigation":"Hide from navigation","title":[{"text":"Child Protection in Social Protection Projects"}]}}},{"node":{"type":"landing_page","uid":"cut-the-engine","lang":"en-us","data":{"show_in_navigation":"Show in navigation","title":[{"text":"#CutTheEngine"}]}}}]},"institutions":{"edges":[{"node":{"uid":"african-development-bank","lang":"en-us","data":{"title":[{"text":"African Development Bank"}]}}},{"node":{"uid":"global-financing-facility","lang":"en-us","data":{"title":[{"text":"Global Financing Facility"}]}}},{"node":{"uid":"world-bank-group","lang":"en-us","data":{"title":[{"text":"World Bank Group"}]}}},{"node":{"uid":"asian-development-bank","lang":"en-us","data":{"title":[{"text":"Asian Development Bank"}]}}},{"node":{"uid":"البنك-الافريقي-للتنمي","lang":"ar-eg","data":{"title":[{"text":"البنك الإفريقيّ للتنمي"}]}}},{"node":{"uid":"البنك-الدولي","lang":"ar-eg","data":{"title":[{"text":"مجموعة البنك الدولي"}]}}},{"node":{"uid":"بنك-التنمية-للبلدان-الامريكية","lang":"ar-eg","data":{"title":[{"text":"بنك التنمية للبلدان الأمريكية"}]}}},{"node":{"uid":"البنك-الاسيوي-للتنمية","lang":"ar-eg","data":{"title":[{"text":"البنك الأسيوي للتنمية"}]}}},{"node":{"uid":"البنك-الاسيوي-للاستثمار-في-البنية-التحتية","lang":"ar-eg","data":{"title":[{"text":"البنك الآسيوي للاستثمار في البنية التحتية"}]}}},{"node":{"uid":"البرنامج-العالمي-لتسهيلات-التمويل-الميسر-هو-صندوق","lang":"ar-eg","data":{"title":[{"text":"البرنامج العالمي لتسهيلات التمويل الميسّر"}]}}},{"node":{"uid":"world-bank-group---spanish1","lang":"es-mx","data":{"title":[{"text":"Grupo Banco Mundial"}]}}},{"node":{"uid":"banco-asiatico-de-inversion-en-infraestructura","lang":"es-mx","data":{"title":[{"text":"Banco Asiático de Inversión en Infraestructura"}]}}},{"node":{"uid":"banco-interamericano-de-desarrollo","lang":"es-mx","data":{"title":[{"text":"Banco Interamericano de Desarrollo"}]}}}]}},"layoutContext":{}}

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(270);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(111);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  * {\n    box-sizing: border-box;\n    &::selection {\n      color: #fff;\n      background-color: #7673c0;\n    }\n  }\n  html {\n    lang: en-us;\n    height: 100%;\n    font-family: 'Noto Sans', system-ui, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    &:not(:lang(ar)) { direction: ltr; }\n    &:lang(ar) { direction: rtl; }\n  }\n  body {\n    background-color: #7673c0;\n    transition: background-color 800ms ease;\n  }\n  a { text-decoration: none; }\n"], ["\n  ", "\n  * {\n    box-sizing: border-box;\n    &::selection {\n      color: #fff;\n      background-color: #7673c0;\n    }\n  }\n  html {\n    lang: en-us;\n    height: 100%;\n    font-family: 'Noto Sans', system-ui, sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    &:not(:lang(ar)) { direction: ltr; }\n    &:lang(ar) { direction: rtl; }\n  }\n  body {\n    background-color: #7673c0;\n    transition: background-color 800ms ease;\n  }\n  a { text-decoration: none; }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(117);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _polished = __webpack_require__(8);
	
	var _theme = __webpack_require__(13);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _MobileBar = __webpack_require__(140);
	
	var _MobileBar2 = _interopRequireDefault(_MobileBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject, (0, _polished.normalize)());
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.determineColor = function (region) {
	      var color = "violet";
	      if (region.indexOf("update") !== -1 || region.indexOf("institution") !== -1 || region.indexOf("campaign") !== -1 || region === null || region === undefined) {
	        if (region.indexOf("institutions") === -1 && region.indexOf("campaigns") === -1 && region.indexOf("updates") === -1) {
	          color = "violet";
	        }
	      }
	      if (region.indexOf("region") !== -1) {
	        if (region.indexOf("africa") !== -1) {
	          color = "green";
	        }
	        if (region.indexOf("middle-east-and-north-africa") !== -1) {
	          color = "orange";
	        }
	        if (region.indexOf("latin-america") !== -1) {
	          color = "blue";
	        }
	        if (region.indexOf("asia") !== -1) {
	          color = "pink";
	        }
	        if (region.indexOf("europe--central-asia") !== -1) {
	          color = "yellow";
	        }
	      }
	      if (region.indexOf("project") === -1 && region.indexOf("update") === -1 || region.indexOf("updates") !== -1) {
	        if (region.split("/")[region.split("/").length - 1] === "") {
	          document.body.style.background = "white";
	        } else {
	          document.body.style.background = _theme2.default.colors[color];
	        }
	      }
	    };
	
	    _this.setAltLanguages = function (altLanguages) {
	      _this.setState({ altLanguages: altLanguages });
	    };
	
	    _this.changeLang = function (lang) {
	      var alt = false;
	      if (_this.state.altLanguages) {
	        if (_this.state.altLanguages[0]) {
	          alt = true;
	          _this.state.altLanguages.forEach(function (element) {
	            if (lang === "English") {
	              if (element.lang === "en-us") {
	                window.location.href = "/en-us/" + (element.type !== "projec" ? element.type : "project") + "/" + element.uid;
	              }
	            }
	            if (lang === "Arabic") {
	              if (element.lang === "ar-eg") {
	                window.location.href = "/ar-eg/" + (element.type !== "projec" ? element.type : "project") + "/" + element.uid;
	              }
	            }
	            if (lang === "Spanish") {
	              if (element.lang === "es-mx") {
	                window.location.href = "/es-mx/" + (element.type !== "projec" ? element.type : "project") + "/" + element.uid;
	              }
	            }
	          });
	        }
	      }
	      if (!alt) {
	        if (lang === "English") {
	          if (window.location === "https://bankinformationcenter.org/ar-eg/" || "https://bankinformationcenter.org/es-mx/") {
	            window.location = "https://bankinformationcenter.org/";
	          }
	          if (window.location.href.indexOf("en-us") === -1) {
	            if (window.location.href.indexOf("ar-eg") !== -1) {
	              if (window.location.href === "https://bankinformationcenter.org/ar-eg/" || window.location.href === "http://localhost:8000/ar-eg/") {
	                window.location.href = window.location.href.replace("/ar-eg/", "/");
	              } else {
	                window.location.href = window.location.href.replace("ar-eg", "en-us");
	              }
	            }
	            if (window.location.href.indexOf("es-mx") !== -1) {
	              if (window.location.href === "https://bankinformationcenter.org/es-mx/" || window.location.href === "http://localhost:8000/es-mx/") {
	                window.location.href = window.location.href.replace("/es-mx/", "/");
	              } else {
	                window.location.href = window.location.href.replace("es-mx", "en-us");
	              }
	            }
	          }
	        }
	        if (lang === "Arabic") {
	          if (window.location.href.indexOf("ar-eg") === -1) {
	            if (window.location.href.indexOf("en-us") !== -1) {
	              window.location.href = window.location.href.replace("en-us", "ar-eg");
	            }
	            if (window.location.href.indexOf("es-mx") !== -1) {
	              window.location.href = window.location.href.replace("es-mx", "ar-eg");
	            }
	            if (window.location.href === "https://bankinformationcenter.org/" || window.location.href === "http://bic-field.netlify.com/" || window.location.href === "http://localhost:8000/" || window.location.href === "http://localhost:8000/___graphql") {
	              window.location.href = window.location.href + "ar-eg/";
	            }
	          }
	        }
	        if (lang === "Spanish") {
	          if (window.location.href.indexOf("es-mx") === -1) {
	            if (window.location.href.indexOf("en-us") !== -1) {
	              window.location.href = window.location.href.replace("en-us", "es-mx");
	            }
	            if (window.location.href.indexOf("ar-eg") !== -1) {
	              window.location.href = window.location.href.replace("ar-eg", "es-mx");
	            }
	            if (window.location.href === "https://bankinformationcenter.org/" || window.location.href === "http://bic-field.netlify.com/" || window.location.href === "http://localhost:8000/" || window.location.href === "http://localhost:8000/___graphql") {
	              window.location.href = window.location.href + "es-mx/";
	            }
	          }
	        }
	      }
	      if (lang === "English") {
	        document.documentElement.lang = "en-us";
	      }
	      if (lang === "Arabic") {
	        document.documentElement.lang = "ar-eg";
	      }
	      if (lang === "Spanish") {
	        document.documentElement.lang = "es-mx";
	      }
	      _this.setState({
	        language: lang,
	        windowLang: document.documentElement.lang
	      });
	    };
	
	    _this.state = {
	      language: "English",
	      windowLang: "en-us",
	      altLanguages: undefined,
	      navMessage: ""
	    };
	    _this.node = undefined;
	    return _this;
	  }
	
	  Index.prototype.componentDidMount = function componentDidMount(props) {
	    if (window.location.href !== "https://bankinformationcenter.org/" && window.location.href !== "http://bic-field.netlify.com/" && window.location.href !== "http://localhost:8000/" && window.location.href !== "http://localhost:8000/___graphql" && window.location.href !== "https://bankinformationcenter.org/thanks" && window.location.href !== "http://localhost:8000/thanks") {
	      if (window.location.href.indexOf("en-us") === -1 && window.location.href.indexOf("ar-eg") === -1 && window.location.href.indexOf("es-mx") === -1) {
	        var split = window.location.href.split("/");
	        var finalSplit = "";
	        split.forEach(function (element, index) {
	          if (index === 3) {
	            finalSplit += "en-us/";
	          }
	          if (index !== split.length - 1) {
	            finalSplit += element + "/";
	          } else {
	            finalSplit += element;
	          }
	        });
	        window.location = finalSplit;
	      } else {
	        if (window.location.href.indexOf("en-us") !== -1) {
	          this.setState({ language: "English", windowLang: "en-us" });
	        }
	        if (window.location.href.indexOf("es-mx") !== -1) {
	          this.setState({ language: "Spanish", windowLang: "es-mx" });
	        }
	        if (window.location.href.indexOf("ar-eg") !== -1) {
	          this.setState({ language: "Arabic", windowLang: "ar-eg" });
	        }
	      }
	    } else {
	      this.setState({ language: "English", windowLang: "en-us" });
	    }
	    this.determineColor(window.location.href);
	    this.setLang(window.location.href);
	    this.setState({ mounted: true });
	  };
	
	  Index.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.location.pathname !== this.props.location.pathname) {
	      this.setLang(nextProps.location.pathname);
	      this.determineColor(nextProps.location.pathname);
	    }
	  };
	
	  Index.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      if (_this2.state.navMessage !== "Navigated to " + document.title.split("|")[0]) {
	        _this2.setState({
	          navMessage: "Navigated to " + document.title.split("|")[0]
	        });
	      }
	    }, 500);
	    if (this.node) {
	      this.node.focus();
	    }
	  };
	
	  Index.prototype.setLang = function setLang(url) {
	    document.documentElement.lang = "en-us";
	    if (url.indexOf("es-mx") !== -1) {
	      document.documentElement.lang = "es-mx";
	    }
	    if (url.indexOf("ar-eg") !== -1) {
	      document.documentElement.lang = "ar-eg";
	    }
	  };
	
	  Index.prototype.getChildContext = function getChildContext() {
	    return { setAltLanguages: this.setAltLanguages };
	  };
	
	  Index.prototype.render = function render() {
	    var _this3 = this;
	
	    if (this.props.data.campaigns) {
	      this.props.data.campaigns.edges.sort(function (a, b) {
	        if (a.node.uid < b.node.uid) return -1;
	        if (a.node.uid > b.node.uid) return 1;
	        return 0;
	      });
	    }
	    if (this.props.data.institutions) {
	      this.props.data.institutions.edges.sort(function (a, b) {
	        if (a.node.uid < b.node.uid) return -1;
	        if (a.node.uid > b.node.uid) return 1;
	        return 0;
	      });
	    }
	    if (this.props.data.regions) {
	      this.props.data.regions.edges.sort(function (a, b) {
	        if (a.node.uid < b.node.uid) return -1;
	        if (a.node.uid > b.node.uid) return 1;
	        return 0;
	      });
	    }
	    return _react2.default.createElement(
	      _styledComponents.ThemeProvider,
	      { theme: _theme2.default },
	      _react2.default.createElement(GlobalStyle, null),
	      _react2.default.createElement(
	        "div",
	        { ref: function ref(n) {
	            return _this3.node = n;
	          }, tabIndex: -1 },
	        _react2.default.createElement(
	          "div",
	          { role: "status", "aria-live": "polite", "aria-atomic": "true" },
	          this.state.navMessage
	        ),
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          null,
	          _react2.default.createElement(
	            "script",
	            null,
	            "\n              window.markerConfig = {\n                project: '637d24536ca403dd22405084', \n                source: 'snippet'\n              };\n            "
	          ),
	          _react2.default.createElement(
	            "script",
	            null,
	            "\n            !function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};[\"show\",\"hide\",\"isVisible\",\"capture\",\"cancelCapture\",\"unload\",\"reload\",\"isExtensionInstalled\",\"setReporter\",\"setCustomData\",\"on\",\"off\"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement(\"script\");s.async=1,s.src=\"https://edge.marker.io/latest/shim.js\";var i=r.getElementsByTagName(\"script\")[0];i.parentNode.insertBefore(s,i)}}(window,document);\n            "
	          )
	        ),
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: "Bank Information Center",
	          meta: [{ name: "application-name", content: "Bank Information Center" }, { name: "msapplication-TileColor", content: "#7673C0" }, {
	            name: "msapplication-TileImage",
	            content: (0, _gatsbyLink.withPrefix)("/favicons/mstile-144x144.png")
	          }],
	          link: [{
	            rel: "icon",
	            type: "image/x-icon",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/favicon.ico")
	          }, {
	            rel: "icon",
	            type: "image/png",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/favicon-32x32.png"),
	            sizes: "32x32"
	          }, {
	            rel: "icon",
	            type: "image/png",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/favicon-16x16.png"),
	            sizes: "16x16"
	          }, {
	            rel: "apple-touch-icon-precomposed",
	            sizes: "57x57",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/apple-touch-icon-57x57.png")
	          }, {
	            rel: "apple-touch-icon-precomposed",
	            sizes: "72x72",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/apple-touch-icon-72x72.png")
	          }, {
	            rel: "apple-touch-icon-precomposed",
	            sizes: "114x114",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/apple-touch-icon-114x114.png")
	          }, {
	            rel: "apple-touch-icon-precomposed",
	            sizes: "120x120",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/apple-touch-icon-120x120.png")
	          }, {
	            rel: "apple-touch-icon-precomposed",
	            sizes: "144x144",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/apple-touch-icon-144x144.png")
	          }, {
	            rel: "apple-touch-icon-precomposed",
	            sizes: "152x152",
	            href: (0, _gatsbyLink.withPrefix)("/favicons/apple-touch-icon-152x152.png")
	          }]
	        }),
	        _react2.default.createElement(_components.Header, {
	          changeLang: this.changeLang,
	          currentLang: this.state.language,
	          props: this.props,
	          windowLang: this.state.windowLang
	        }),
	        this.props.children(),
	        _react2.default.createElement(_components.Footer, {
	          changeLang: this.changeLang,
	          currentLang: this.state.language,
	          windowLang: this.state.windowLang
	        }),
	        this.state.mounted && _react2.default.createElement(
	          "div",
	          null,
	          window.location.href.split("/")[window.location.href.split("/").length - 1] === "" && _react2.default.createElement(_MobileBar2.default, {
	            emailAddress: "info@bankinformationcenter.org",
	            phoneNumber: "+1 (202) 737-7752",
	            windowLang: this.state.windowLang
	          })
	        )
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	Index.childContextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Index;
	
	
	Index.propTypes = {
	  children: _propTypes2.default.func
	};
	
	if (typeof document !== "undefined") {
	  (function (l) {
	    var i,
	        s = { touchend: function touchend() {} };
	    for (i in s) {
	      l.addEventListener(i, s);
	    }
	  })(document); // sticky hover fix in iOS
	}
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-9f0d46f34d7cbcb52576.js